import { isClient } from "src/utils/isClient";
import { pushToDataLayer } from "./googleTagManager";

// NOTE: `sign_in_platform` and `sign_up_platform` values from the tracking plan
// https://app.notion.com/p/9a938b8637004a71bd4c264dfc78df78

enum SignPlatform {
  APPLE = "apple",
  EMAIL = "email",
  FACEBOOK = "facebook",
  GOOGLE = "google",
  GUEST_LOGIN = "guest_login",
  SOFT_LOGIN = "soft_login",
  WOO_SHOP_TOKEN = "woo_shop_token",
}

enum SignEvent {
  SIGN_IN_STARTED = "SIGN_IN_STARTED",
  SIGN_UP_STARTED = "SIGN_UP_STARTED",
}

enum SignLocation {
  CHECKOUT = "checkout",
  CONFIRMATION_PAGE = "confirmation_page",
  GATED_POPUP = "gated_popup",
  MY_ACCOUNT = "my_account",
  ONE_TAP = "one_tap",
  SIGN_IN_PAGE = "sign_in_page",
  SIGN_UP_PAGE = "sign_up_page",
  USP_BLOCK = "usp_block",
}

const defaultSegmentProperties = {
  request_source: "webReact",
};

enum EVENT_NAME {
  SIGN_IN = "Sign In Started",
  SIGN_UP = "Sign Up Started",
}

const segment = {
  signHandler: (
    type: SignEvent,
    { location }: { location: SignLocation }
  ): void => {
    if (!isClient) return;

    const eventName =
      type === SignEvent.SIGN_IN_STARTED
        ? EVENT_NAME.SIGN_IN
        : EVENT_NAME.SIGN_UP;
    const properties = { ...defaultSegmentProperties, location };

    void window.htevents.track(eventName, properties);
    pushToDataLayer({ event: eventName, ...properties });
  },
};

export {
  segment,
  SignPlatform,
  SignEvent,
  SignLocation,
  defaultSegmentProperties,
};
